module.exports = __webpack_public_path__ + "static/img/cross.c39b35d3.svg";